export default __webpack_public_path__ + "static/media/autoconsumo-individual-sin-excedentes.e09b7e73.png";